/**
 * WEB-3768 (решение владельца 25.10 п. 79, 27.10: «имейлы скрыть с прода, код
 * не вырезать») — маршрут только при флаге черновика кабинета.
 *
 * Флаг выключен (бой) — сразу посадка кабинета `LandingRedirect`
 * (`router/landingRoute.tsx`, WEB-4091): один переход с заменой записи истории
 * туда, куда ведёт `/` (`/home` при активном проекте, `/org/dashboard` или
 * `/projects` в режиме организации), без промежуточного `/`; пока проекты не
 * загружены — `Preloader`, как у посадки. Детей в дереве нет вовсе, ленивая
 * страница не грузится и запросов не шлёт. Флаг включён (стенд, локально) —
 * дети как есть. Флаг — через `useDraftEnabled` (`components/kit`), как велит
 * `config/draft-enabled.ts`.
 *
 * Сейчас за ним адреса раздела «Email-цепочки» (`router/sections/project.tsx`);
 * пункт меню и палитры прячет `projectShellMenu` тем же флагом.
 */
import React from 'react';
import { useDraftEnabled } from '@/components/kit/useDraftEnabled';
import LandingRedirect from './landingRoute';

export function DraftRoute({ children }: { children: React.ReactNode }) {
  const draft = useDraftEnabled();
  if (!draft) return <LandingRedirect />;
  return <>{children}</>;
}
